/*
**************************************************************************
Title:          Chat message component
Created By:     Pankaj Arora
Created on:     05/04/2018
Description:    This shows user messages
**************************************************************************
*/
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UserService } from './../services/users/user.service';
import { Message } from './../services/messages/message.model';
import { User } from './../services/users/user.model';

@Component({
    selector: 'app-chat-message',
    templateUrl: './chat-message.component.html',
    styleUrls: ['./chat-message.component.css'],
    standalone: false
})
export class ChatMessageComponent implements OnInit {
  @Input() message: Message;
  @Input() isActive: boolean;
  @Output() selectedOption = new EventEmitter();
  @Output() selectedListItem = new EventEmitter();
  @Output() selectedItem = new EventEmitter();

  currentUser: User;
  botUser: User;
  incoming: boolean;

  currentPage = 1;
  pageSize = 5;
  searchText = '';
  nodes = [
    {
      label: 'Floor1',
      showChildren: false,
      children: [
        {
          label: 'Algeria',
          showChildren: false,
          children: [
            {
              label: 'Algeris',
              showChildren: false,
              children: []
            },
            {
              label: 'Algeria child 2',
              showChildren: false,
              children: []
            },
          ]
        }]
    },
    {
      label: 'Angola',
    },
  ];

  constructor(public usersService: UserService) {
  }

  ngOnInit() {
    // subscribe to current user
    this.usersService.currentUser
      .subscribe(
        (user: User) => {
          this.currentUser = user;
          if (this.message.author && user) {
            this.incoming = this.message.author.id !== user.id;
          }
        });

    // subscribe to bot user
    this.usersService.botUser.subscribe(
      (user: User) => this.botUser = user);
  }

  onSelectedOptionClick(selectedOption) {
    this.selectedOption.emit(selectedOption);
    event.preventDefault();
  }

  onSelectedListItemClick(listItem) {
    this.selectedListItem.emit(listItem);
    event.preventDefault();
  }

  onSelectedTreeItemClick(option: any) {
    this.selectedListItem.emit(option);
    event.preventDefault();
  }

  isString(val) {
    return typeof val === 'string';
  }

}
